import {
  MandatoryProcessTasksDocument,
  MandatoryProcessTasksQueryVariables,
} from 'generated/resources/datatable.graphql'
import {
  GetProcessAnalyticsDocument,
  TasksValueObjectsTaskIdentifierEnum,
} from 'generated/resources/graphql'

import { useBulkUpdateTasks } from 'modules/tasks/hooks/useBulkUpdateTasks'

interface IVariable {
  ids: string[]
  done: boolean
  identifier?: TasksValueObjectsTaskIdentifierEnum
}

type ResolveTaskProps = {
  variables: IVariable
  refecthVars: MandatoryProcessTasksQueryVariables
}

export const useBulkResolveOverviewTasks = () => {
  const { bulkUpdateTasks, loading } = useBulkUpdateTasks()

  return {
    resolveTasks: ({ variables, refecthVars }: ResolveTaskProps) => {
      return bulkUpdateTasks({
        variables: {
          tasks: variables.ids.map((id) => ({
            id,
            status: variables.done ? 'done' : 'todo',
            identifier: variables.identifier,
          })),
        },
        refetchQueries: [
          {
            query: GetProcessAnalyticsDocument,
            variables: {
              processId: refecthVars.processId,
              status: 'incompleted',
              mandatory: true,
              category: refecthVars.category,
            },
          },
          {
            query: MandatoryProcessTasksDocument,
            variables: {
              ...refecthVars,
            },
          },
        ],
        awaitRefetchQueries: true,
      })
    },
    loading,
  }
}
